import React from 'react';
import { DroneTypeChoice } from '../types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/ui/select';
import { Label } from '@/shared/ui/label';
import { Loader2 } from 'lucide-react';

interface DroneTypeSelectorProps {
  droneTypes: DroneTypeChoice[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  isLoading?: boolean;
}

export const DroneTypeSelector: React.FC<DroneTypeSelectorProps> = ({
  droneTypes,
  value,
  onChange,
  disabled = false,
  isLoading = false,
}) => {
  const safeTypes = Array.isArray(droneTypes) ? droneTypes : [];

  return (
    <div className="space-y-2">
      <Label htmlFor="drone-type">
        Drone Type <span className="text-destructive">*</span>
      </Label>
      {isLoading ? (
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span>Loading drone types...</span>
        </div>
      ) : (
        <Select
          value={value}
          onValueChange={onChange}
          disabled={disabled}
        >
          <SelectTrigger id="drone-type" className="w-full">
            <SelectValue placeholder="Select Drone Type" />
          </SelectTrigger>
          <SelectContent className="max-h-[300px] overflow-y-auto">
            {safeTypes.map((type) => (
              <SelectItem key={type.value} value={type.value}>
                {type.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
};

